document.addEventListener('DOMContentLoaded', () => {
  const cafePath = '/collections/sophies-cafe-in-store-purchases-only';

  /* set flag whenever Café collection is visited */
  if (location.pathname.startsWith(cafePath)) {
    sessionStorage.setItem('cafeSession', Date.now());
  }

  /* only act on /cart and only for Café sessions */
  if (location.pathname !== '/cart' || !sessionStorage.getItem('cafeSession')) return;

  /* — helper to build the link element — */
  const buildBtn = () => {
    const a = document.createElement('a');
    a.href = cafePath;
    a.textContent = 'Click for more Sophie’s Café items';
    a.className = 'button back-to-cafe-btn';
    a.style.marginLeft = '1rem';
    return a;
  };

  /* — function that (re)inserts the button if missing — */
  const insertBtn = () => {
    /* try header first */
    const header = document.querySelector('.title-wrapper-with-link');
    if (header && !header.querySelector('.back-to-cafe-btn')) {
      header.appendChild(buildBtn());
      return;
    }
    /* fallback for empty-cart notice */
    const emptyTxt = document.querySelector('.cart__empty-text');
    if (emptyTxt && !document.querySelector('.back-to-cafe-btn')) {
      emptyTxt.insertAdjacentElement('afterend', buildBtn());
    }
  };

  /* initial insert */
  insertBtn();

  /* watch the cart area for re‑renders (Dawn swaps the DOM) */
  const cartRoot = document.querySelector('cart-items') || document.body;
  const obs = new MutationObserver(() => insertBtn());
  obs.observe(cartRoot, { childList: true, subtree: true });
});